import { SelectProps, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SelectStyled = styled(Select)<SelectProps>(({ theme }) => ({
  '&.MuiSelect-root': {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
  },
}));
